<template>
    <div class="OvertimeRegistration" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>加班登记</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="访客状态">
                                    <!-- <el-input v-model="queryform.status"></el-input> -->
                                    <el-select clearable v-model="queryform.status" placeholder="请选择">
                                        <el-option
                                        label="待审核"
                                        :value="0">
                                        </el-option>
                                        <el-option
                                        label="已审核"
                                        :value="1">
                                        </el-option>
                                        <el-option
                                        label="已到访"
                                        :value="2">
                                        </el-option>
                                        <el-option
                                        label="未到访"
                                        :value="3">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-button type="primary" @click="AddOvertimeRegistration">新增</el-button> -->
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="company_name" label="加班公司">
                    </el-table-column>
                    <el-table-column prop="user_name" label="加班登记人" show-overflow-tooltip>
                    </el-table-column>
                    <!-- <el-table-column prop="area" label="访客门禁">
                    </el-table-column> -->
                    <el-table-column prop="mobile" label="加班人数">
                    </el-table-column>
                    <el-table-column prop="timeS" label="开始时间">
                    </el-table-column>
                    <el-table-column prop="timeE" label="结束时间">
                    </el-table-column>
                    <el-table-column prop="timeE" label="状态">
                        <template slot-scope="scope">
                            <span v-if="Number(scope.row.status) === 0">未过期</span>
                            <span v-if="Number(scope.row.status) === 1">已过期</span>
                            <!-- <span v-if="Number(scope.row.status) === 2">已到访</span>
                            <span v-if="Number(scope.row.status) === 3">未到访</span> -->
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" v-if="Number(scope.row.status) === 0" @click="Agree(scope.row)">同意</el-button>
                            <el-button v-if="Number(scope.row.is_read) == 0 && Number(scope.row.status) === 0"  type="text" @click="Ignore(scope.row)">忽略</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <!-- <el-dialog :title="title" :visible.sync="OvertimeRegistration" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="OvertimeRegistration">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="公司名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="第一联系人">
                            <el-input v-model="form.contact"></el-input>
                        </el-form-item>
                        <el-form-item label="第一联系人电话" prop="tel">
                            <el-input v-model="form.tel"></el-input>
                        </el-form-item>
                        <el-form-item label="第二联系人">
                            <el-input v-model="form.contact1"></el-input>
                        </el-form-item>
                        <el-form-item label="第二联系人电话" prop="tel1">
                            <el-input v-model="form.tel1"></el-input>
                        </el-form-item>
                        <el-form-item label="房间号">
                            <el-input v-model="form.room"></el-input>
                        </el-form-item>
                        <el-form-item label="公司状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option label="停用" :value="0">
                                </el-option>
                                <el-option label="正常" :value="1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司简介" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.intro"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.remark"></el-input>
                        </el-form-item>
                        <el-form-item label="公司logo" style="display: block; width: 100%;">
                           <el-upload
                                class="upload-demo"
                                :action="http + '/Spaceorder/upload_file'"
                                :data="Uploaddata"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                :on-success="SiteUploadSuccess"
                                :before-upload="SiteBeforeUpload"
                                multiple
                                :limit="1"
                                :on-exceed="handleExceed"
                                :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="OvertimeRegistration = false">取 消</el-button>
                        <el-button type="primary" @click="SaveOvertimeRegistration" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog> -->
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "OvertimeRegistration",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            OvertimeRegistration: false,
            form: {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                status: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                tel1: [
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ]
            },
            confirmloding: false
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        AddOvertimeRegistration () {
            this.OvertimeRegistration = true
            this.title = '新增公司'
            this.form = {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1
            }
            this.fileList = []
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetOvertimeRegistrationList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetOvertimeRegistrationList()
        },
        GetOvertimeRegistrationList (keyword, room) {
            let data = {
                status: this.queryform.status,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('AuditvisitorsListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                this.tableData = res.data
                this.form = {
                    title: '',
                    contact: '',
                    tel: '',
                    contact1: '',
                    tel1: '',
                    remark: '',
                    img: [],
                    intro: '',
                    room: '',
                    status: 1
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                status: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.GetOvertimeRegistrationList()
        },
        handleRemove(file, fileList) {
             this.form.img = fileList
            //  console.log(fileList)
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        SiteBeforeUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJPG) {
                this.$message.error('只能上传jpeg或png图片！');
            }
            return isJPG;
        },
        SiteUploadSuccess(response, file, fileList) {
            this.form.img = fileList
        },
        SaveOvertimeRegistration() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.img = JSON.stringify(this.form.img)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true
                    that.$store.dispatch('SaveOvertimeRegistration', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.confirmloding = false
                            that.OvertimeRegistration = false
                            that.fullscreenLoading = true
                            that.GetOvertimeRegistrationList()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    // that.$message({
                    //     message: '请先填写必填项',
                    //     type: 'error'
                    // })
                    return false;
                }
            });
            
        },
        Agree (row) {
            let data = JSON.parse(JSON.stringify(row));
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            this.$store.dispatch('AgreeOvertimeRegistration', data).then(res => {
                if (res.flag) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    this.fullscreenLoading = true;
                    this.GetOvertimeRegistrationList();
                    this.HongDian();
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                }
            });
        },
        Ignore (row) {
            this.$confirm('是否忽略该访客？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('IgnoreOvertimeRegistration', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.fullscreenLoading = true;
                        this.GetOvertimeRegistrationList();
                        this.HongDian();
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                    }
                });
            }).catch(() => {
            });
        },
        HongDian () {
            let data = {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            };
            this.$store.dispatch("Isread", data).then(res => {
                console.log(res);
            });
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetOvertimeRegistrationList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.OvertimeRegistration {
    width: 100%;
}
.OvertimeRegistration .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.OvertimeRegistration .el-header .el-row .el-col h2 {
    text-align: center;
}
.OvertimeRegistration .el-header .el-row .el-col {
    text-align: center;
}
.OvertimeRegistration .el-header .el-row .el-col:last-child {
    text-align: right;
}
.OvertimeRegistration .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.OvertimeRegistration .el-main .el-table tr td {
    height: 40px !important;
}
.OvertimeRegistration .el-main .OvertimeRegistration .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.OvertimeRegistration .el-main .OvertimeRegistration .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
}
</style>
